import Head from "next/head";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { RESTAURANT_IMAGE_TYPE } from "../../../utils/enums";
import env from "../../../utils/env.config";
import { capitalizeFirstLetter } from "../../../utils/help/textPreparation/textPreparation";
import { Restaurant } from "../../../utils/types";

export const PHead = (props: {
  restaurantInfo?: Restaurant;
  title?: any;
  socialMediaInfo?: {
    fbId: string;
    googleTagsManager: string;
    fbDomainVerificationId: string;
    tiktokId: string;
  };
}) => {
  const propsSocialMediaInfo = props.socialMediaInfo;
  const propsRestaurantInfo = props.restaurantInfo;
  const { restaurantInfo, socialMedia } = useAppSelector(
    (state) => state.config
  );

  const [css, setCss] = useState("");
  const currentRestaurantData = restaurantInfo || propsRestaurantInfo;
  useEffect(() => {
    if (
      !env.featureGetColorsInAppJS &&
      env.restaurantId &&
      env.restaurantId.toString().match("[0-9]+")
    ) {
      let css = "";
      if (currentRestaurantData && currentRestaurantData.colors) {
        Object.entries(currentRestaurantData.colors).forEach(([key, value]) => {
          if (key !== "theme" && key !== "invertedSections") {
            if (key === "navBarIconsColor") {
              css += "--nav-bar-icons-color:" + value + " !important;";
            } else {
              css += "--" + key + "-color:" + value + " !important;";
            }
          }
        });
        if (currentRestaurantData.colors.theme === "main_dark") {
          css += "color:#fff;.invert{color:var(--main-text);}";
        }
        css = `body.${currentRestaurantData.colors.theme || "light"}{
                      ${css}
                    }`;
        setCss(css);
      }

      if (
        currentRestaurantData &&
        currentRestaurantData.colors &&
        currentRestaurantData.colors.theme
      ) {
        document.body.classList.add(currentRestaurantData.colors!.theme);
      } else {
        document.body.classList.add("light");
      }
      createManifestLink(currentRestaurantData);
    }
  }, [propsRestaurantInfo, restaurantInfo, propsSocialMediaInfo]);
  const createManifestLink = (
    currentRestaurantData: Restaurant | undefined
  ) => {
    const restaurantImageLogo = currentRestaurantData?.restaurantImages?.find(
      (im) => im.type === RESTAURANT_IMAGE_TYPE.FAVICON
    );
    const iconPath: string | undefined =
      restaurantImageLogo?.url || currentRestaurantData?.logoUrl;

    const getlinkManifest = document.getElementById("head_manifest");
    const getScriptManifest = document.getElementById("script_manifest");
    const manifestJSON = {
      name: currentRestaurantData?.name,
      short_name: currentRestaurantData?.name,
      icons: [
        {
          src: iconPath,
          sizes: "192x192",
          type: "image/png",
        },
      ],
      start_url: "/",
      display: "standalone",
    };
    // ANDROID AND OTHER DEVICES ICON
    const iconLink: any = document.createElement("link");
    iconLink.rel = "icon";
    iconLink.href = iconPath;
    iconLink.sizes = "192x192";

    // IOS ICON
    const appleTouchIcon: any = document.createElement("link");
    appleTouchIcon.rel = "apple-touch-icon";
    appleTouchIcon.href = iconPath;
    appleTouchIcon.sizes = "180x180";
    appleTouchIcon.id = "apple-touch-icon";

    const manifest = document.createElement("link");
    manifest.id = "head_manifest";
    manifest.rel = "manifest";
    manifest.href = "#manifest";

    const manifestScript = document.createElement("script");
    manifestScript.id = "script_manifest";
    manifestScript.type = "application/json";
    manifestScript.textContent = JSON.stringify(manifestJSON);

    if (!getlinkManifest) {
      document.head.appendChild(iconLink);
      document.head.appendChild(appleTouchIcon);
      document.head.appendChild(manifest);
    }
    if (!getScriptManifest) {
      document.body.appendChild(manifestScript);
    }
  };
  const openGraphImage = currentRestaurantData?.restaurantImages?.find(
    (im) => im.type === RESTAURANT_IMAGE_TYPE.OPEN_GRAPH
  );

  const restaurantImage = openGraphImage?.url || currentRestaurantData?.logoUrl;

  const restaurantName = capitalizeFirstLetter(
    props.title || currentRestaurantData?.name
  );

  return (
    <Head>
      {props.title && (
        <title translate="no" className="notranslate">
          {restaurantName}
        </title>
      )}

      <meta name="google" content="notranslate" />

      <style id="theme_style" data-id={`_${env.restaurantId}`}>
        {css}
      </style>

      <meta
        name="facebook-domain-verification"
        content={
          propsSocialMediaInfo?.fbDomainVerificationId ||
          socialMedia?.fbDomainVerificationId
        }
      />

      <meta
        property="og:title"
        content={restaurantName}
        data-translate="false"
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content={`Welcome to ${currentRestaurantData?.name}!`}
        data-translate="false"
      />
      <meta property="og:image" content={restaurantImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta http-equiv="Content-Language" content="en" />
      <meta name="language" content="English" />
    </Head>
  );
};
